import { render, staticRenderFns } from "./GoodsReturnEdit.vue?vue&type=template&id=a36f1fda"
import script from "./GoodsReturnEdit.vue?vue&type=script&lang=js"
export * from "./GoodsReturnEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports